import React, { FC } from 'react';
import {
  FooterNavWrapper,
  FooterGridList,
  FooterHeading,
  FooterList,
  FooterLink,
  FooterEyebrow,
} from './navigation.styled';
import { TypeCaption } from 'components/library/Typography';
import {
  NavigationProps,
  NavigationItem,
  SubNavItem,
} from './navigation.types';

const FooterNav: FC<NavigationProps> = ({ footerNavigation }) => {
  return (
    <FooterNavWrapper aria-label='Footer'>
      <FooterGridList>
        {footerNavigation.map((item: NavigationItem, index: number) => (
          <FooterHeading key={index}>
            <FooterEyebrow>{item.label}</FooterEyebrow>
            <FooterList>
              {item.subNavLists.map((subitem: SubNavItem, index: number) => (
                <TypeCaption as='li' key={index}>
                  <FooterLink
                    as='a'
                    href={subitem.url}
                    {...(subitem.action
                      ? {
                          onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
                            e.preventDefault();
                            subitem.action && subitem.action();
                          },
                        }
                      : {})}
                  >
                    {subitem.label}
                  </FooterLink>
                </TypeCaption>
              ))}
            </FooterList>
          </FooterHeading>
        ))}
      </FooterGridList>
    </FooterNavWrapper>
  );
};

export default FooterNav;
